export default __webpack_public_path__ + "static/media/ebloc3.31a89cb9.png";